/** Códigos de erro do módulo de anexos (RN-105). */
export const ATTACHMENT_ERROR = {
  UNSUPPORTED_TYPE: 'ATTACHMENT.UNSUPPORTED_TYPE',
  CONTENT_MISMATCH: 'ATTACHMENT.CONTENT_MISMATCH',
  FILE_TOO_LARGE: 'ATTACHMENT.FILE_TOO_LARGE',
  FILE_EMPTY: 'ATTACHMENT.FILE_EMPTY',
  TOO_MANY_FILES: 'ATTACHMENT.TOO_MANY_FILES',
  NOT_FOUND: 'ATTACHMENT.NOT_FOUND',
  CAPTION_REQUIRED: 'ATTACHMENT.CAPTION_REQUIRED',
  CAPTION_TOO_LONG: 'ATTACHMENT.CAPTION_TOO_LONG',
} as const;

export const ATTACHMENT_ERROR_MESSAGE: Readonly<Record<string, string>> = {
  [ATTACHMENT_ERROR.UNSUPPORTED_TYPE]: 'Formato não aceito. Envie foto JPEG, PNG, WebP ou PDF.',
  [ATTACHMENT_ERROR.CONTENT_MISMATCH]:
    'O conteúdo do arquivo não corresponde à extensão. Envie o arquivo original da câmera.',
  [ATTACHMENT_ERROR.FILE_TOO_LARGE]: 'Arquivo acima do limite de 10 MB.',
  [ATTACHMENT_ERROR.FILE_EMPTY]: 'Arquivo vazio.',
  [ATTACHMENT_ERROR.TOO_MANY_FILES]: 'Já são 10 anexos, o máximo por dia.',
  [ATTACHMENT_ERROR.NOT_FOUND]: 'Anexo não encontrado.',
  [ATTACHMENT_ERROR.CAPTION_REQUIRED]:
    'Escreva a legenda da foto. Ela é o que diz, no relatório fotográfico, o que se está vendo.',
  [ATTACHMENT_ERROR.CAPTION_TOO_LONG]: 'A legenda passou do tamanho máximo.',
};
